import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import ButtonGroup from './ButtonGroup';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  min-height: 60px;
  z-index: 2;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);
  @media (max-width: 679px) {
    min-height: 56px;
    padding: 0 12px;
  }
`;

const RightColumn = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;


const TopBar = ({ isMeasuring }: { isMeasuring?: boolean }) => {
  return (
    <Wrapper>
      <div />
      <Logo />
      <RightColumn>
        <ButtonGroup />
      </RightColumn>
    </Wrapper>
  );
};

export default TopBar;
